"use strict";
exports.__esModule = true;
exports.CurrencyTextField = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var Form_1 = require("../Form");
var TextField_1 = require("./TextField");
var CurrencyTextField = function (props) {
    var _a = react_1.useState((props === null || props === void 0 ? void 0 : props.value) || ''), value = _a[0], setValues = _a[1];
    var handleChange = function (event) {
        var _a;
        setValues(event.target.value);
        (_a = props.onCurrencyChange) === null || _a === void 0 ? void 0 : _a.call(props, event.target.value);
    };
    var formattedNumber = react_1.useMemo(function () {
        return Number(value.replaceAll(',', '')).toLocaleString(navigator.language);
    }, [value]);
    return (react_1["default"].createElement(TextField_1.TextField, tslib_1.__assign({}, props, { InputProps: {
            startAdornment: (react_1["default"].createElement(Form_1.InputAdornment, { position: "start" }, props.currency))
        }, fullWidth: true, onChange: handleChange, placeholder: props.placeholder, value: formattedNumber })));
};
exports.CurrencyTextField = CurrencyTextField;
//# sourceMappingURL=CurrencyTextField.js.map